import { Button, Skeleton, Stack } from "@mui/material";
import React from "react";
import useGetDataFromSelect from "src/hooks/useGetDataFromSelect";

export default function BtnGroupDynamic({ path, params, handlePickOptionSearch, paramsQuery, name }) {
  const { data, isLoading } = useGetDataFromSelect(path, params);

  return (
    <Stack
      direction="row"
      gap={1}
    >
      {isLoading ? (
        <Skeleton width="100%" />
      ) : (
        <>
          {Array.isArray(data?.data)
            ? data?.data?.map((v) => {
                return (
                  <Button
                    size="small"
                    sx={{
                      height: "35px",
                      fontSize: "12px",
                      mt: "2px",
                      border: paramsQuery?.[name] === v?._id ? "1px solid var(--confirm-txt)" : "1px solid var(--light-grey)",
                      color: paramsQuery?.[name] === v?._id ? "var(--confirm-txt)" : "var(--black)",
                    }}
                    onClick={() =>
                      handlePickOptionSearch({
                        name: name,
                        value: v._id,
                      })
                    }
                    key={v?._id}
                  >
                    {v?.name}
                  </Button>
                );
              })
            : undefined}
        </>
      )}
    </Stack>
  );
}
